import {
  AfterViewInit, ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input, signal,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {AbsetzungEntry, UpdateAbsetzungModel} from '../../../../../Api/DcoApi/Abrechnung/Absetzung';
import {AktePopup} from '../../../Status/AktePopup';
import {Abrechnung} from '../../Abrechnung';
import {Absetzung} from '../../Absetzung';
import {ToastService} from '../../../../../Akte/Services/Toasts/ToastService';
import {PhoneCall} from '../../../../../Componente/PhoneCall';
import {RestClient} from '../../../../../Api/DcoApi/Client/RestClient';
import { InjectionToken, Type } from '@angular/core';
import {AbsetzungsDateien} from '../absetzungs-dateien/absetzungs-dateien';
import {AbsetzungGrundSelect} from '../../Controlls/GruendeSelect';



@Component({
  selector: 'app-absetzungs-edit',
  imports: [
    CommonModule,
    FormsModule, forwardRef(() => Absetzung), PhoneCall, AbsetzungsDateien, AbsetzungGrundSelect
  ],
  templateUrl: './absetzungs-edit.html',
  styleUrl: './absetzungs-edit.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbsetzungsEdit implements AfterViewInit{
  @Input() Entry = signal< AbsetzungEntry>({} as AbsetzungEntry) ;
  ViewLoaded = signal<boolean>(false);
  modal = inject(NgbActiveModal);
  private modalService = inject(NgbModal);
  apiClinet: RestClient = new RestClient();

  StatusData = [
    { key: null, Bezeichnung: "..." },
    { key: 0, Bezeichnung: "SUBMITTED" },
    { key: 1, Bezeichnung: "Bezahlt" },
    { key: 2, Bezeichnung: "Absetzung korrigiert" },
    { key: 3, Bezeichnung: "Absetzung" },
    { key: 4, Bezeichnung: "RESUBMITTED" },
    { key: 5, Bezeichnung: "Stornieren" },
    { key: 6, Bezeichnung: "In Bearbeitung" },
  ]
  toastService: ToastService;

  constructor() {
    this.toastService = inject(ToastService)
  }

  OpenAkten()
  {
    var modal = this.modalService.open(AktePopup);
    modal.componentInstance.Key = this.Entry()?.auftrag;
    modal.componentInstance.versichertenNr = this.Entry()?.versicherungsnummer;
    modal.closed.subscribe({
      next: async (config) => {
        this.LoadData();
      },
      error: (err) => {
        this.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.LoadData();
      },
      error: (err) => {
        this.LoadData();
      },
    });
  }

  async LoadData()
  {
    if(!this.Entry())
      return;
    var newData = await this.apiClinet.Get<AbsetzungEntry>(`/Absetzung/${this.Entry().key}`);
    newData.status = this.Entry() .status;
    newData.freitext_A = this.Entry() .freitext_A;
    newData.freitext_B = this.Entry() .freitext_B;
    this.Entry.set(newData);

  }

  async save()
  {
    if(!this.Entry())
      return;

      try {

        await this.apiClinet.Post<any,UpdateAbsetzungModel>(`/Absetzung/${this.Entry().key}`,  { status: this.Entry().status, freitext_A: this.Entry().freitext_A, freitext_B: this.Entry().freitext_B, grund: this.Entry().grund } as UpdateAbsetzungModel)
        //await this.apiClinet.Post<any,UpdateAbsetzungModel>(`/Absetzung/${this.Entry().key}`,  { status: this.Entry().status, freitext_A: this.Entry().freitext_A, freitext_B: this.Entry().freitext_B } as UpdateAbsetzungModel)
        this.toastService.show({ template: this.successVerTpl, classname: 'bg-success text-light show', delay: 10000 });
      }
      catch (err)
      {
        console.log(err);
        this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
      }
  }

  @ViewChild('successVerTpl') public successVerTpl!: TemplateRef<any>;
  @ViewChild('FaildVerTpl') public FaildVerTpl!: TemplateRef<any>;

  ngAfterViewInit(): void {

  }
}
